import { render, staticRenderFns } from "./WheelDetails.vue?vue&type=template&id=3ad67683&scoped=true"
import script from "./WheelDetails.vue?vue&type=script&lang=js"
export * from "./WheelDetails.vue?vue&type=script&lang=js"
import style0 from "./WheelDetails.vue?vue&type=style&index=0&id=3ad67683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad67683",
  null
  
)

export default component.exports